import { render, staticRenderFns } from "./EditPresets.vue?vue&type=template&id=486c0a2f&scoped=true&"
import script from "./EditPresets.vue?vue&type=script&lang=js&"
export * from "./EditPresets.vue?vue&type=script&lang=js&"
import style0 from "./EditPresets.vue?vue&type=style&index=0&id=486c0a2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c0a2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
